import React from "react";
import Subscriber from "../../subscriber.class";
import atoms from "../../assets/img/new_onboarding/atoms-logo-original.svg";
import carbon from "../../assets/img/new_onboarding/carbon.svg";
import { Logout } from "../../services/user.service";
import Storage from "../../services/storage.service";
import ModalLayout from "../../layouts/modal";
import { isLoggedInProper } from "../../services/helpers";
import { t } from "../../services/translation.service";
import { generalEvent } from "../../services/tracking.service";
export default class Footer extends Subscriber {
  state = {
    logged_in: false,
  };

  logout = (btn) => {
    this.setState({
      showConfirmModal: false,
    });
    Logout({
      callee: "user-initiated",
    });
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("flow_status_flags").subscribe((flow_status_flags) => {
        this.setState({
          logged_in: isLoggedInProper(),
        });
      })
    );
  }

  render() {
    let modalContent = null;
    if (this.state.showConfirmModal) {
      modalContent = (
        <ModalLayout icon={true} size="small" close={false}>
          <h2>{t("LOGOUT_CONFIRMATION_QUESTION")}</h2>
          <div className="vmo-modal-actions">
            <button
              type="button"
              className="vmo-button vmo-button-round vmo-button-wide vmo-button-red"
              onClick={() => 
                {
                this.logout()
                let eventObj = {
                  eventCustomName : "click_cta",
                  extra_obj : {
                      cta_name: t("LOGOUT_MODAL_CONFIRM").toLowerCase(),
                      cta_type: 'button',
                      cta_position: 'bottom'
                  }
              }
              generalEvent(eventObj);
                }
              }
            >
              {t("LOGOUT_MODAL_CONFIRM")}
            </button>
            <button
              type="button"
              className="vmo-button vmo-button-round vmo-button-wide vmo-button-white-bordered"
              onClick={() => {
                this.setState({
                  showConfirmModal: false,
                });
                let eventObj = {
                  eventCustomName : "click_cta",
                  extra_obj : {
                      cta_name: t("LOGOUT_MODAL_CANCEL").toLowerCase(),
                      cta_type: 'button',
                      cta_position: 'bottom'
                  }
              }
              generalEvent(eventObj);
              }}
            >
              {t("LOGOUT_MODAL_CANCEL")}
            </button>
          </div>
        </ModalLayout>
      );
    }

    return (
      <>
        <footer>
          <div className="footer-main">
            <div className="logo">
              <img src={atoms} alt="virgin-mobile-logo" />
              <p>Virgin Mobile UAE. All rights reserved©</p>
            </div>
            <div className="carbon-neutral">
              <img src={carbon} alt="carbon-neutral" />
              <p>Virgin Mobile UAE is now carbon neutral</p>
            </div>
            <div className="links-container">
              <p 
              onClick={() => {
                let eventObj = {
                  eventCustomName : "navigation_footer",
                  extra_obj : {
                    nav_cta_name: t("FOOTER_HELP_LINK").toLowerCase(),
                  }
                }
                generalEvent(eventObj)
              }}
              >
                <a
                  href="https://www.virginmobile.ae/help/"
                  rel="noopener noreferrer"
                  // target="_blank"
                  className="footer-lnk"
                  id="link_help"
                >
                  {t("FOOTER_HELP_LINK")}
                </a>
              </p>
              <div className="hr" />
              <p
                onClick={() => {
                  let eventObj = {
                    eventCustomName : "navigation_footer",
                    extra_obj : {
                      nav_cta_name: t("FOOTER_LEGAL_LINK").toLowerCase(),
                    }
                  }
                  generalEvent(eventObj)
                }}
              >
                <a
                  href="https://www.virginmobile.ae/legal-stuff/"
                  rel="noopener noreferrer"
                  // target="_blank"
                  className="footer-lnk"
                  id="link_legal_stuff"
                >
                  {t("FOOTER_LEGAL_LINK")}
                </a>
              </p>
              {this.state.logged_in ? (
                <>
                  <div className="hr" />
                  <p
                    className="vmo-logout-link"
                    onClick={() => {
                      this.setState({
                        showConfirmModal: true,
                      });
                    }}
                  >
                    {t("FOOTER_LOGOUT")}
                  </p>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </footer>

        {modalContent}
      </>
    );
  }
}
